import { Outlet } from "@tanstack/react-router";
import { Suspense, lazy } from "react";

const TanStackRouterDevtools =
  process.env.NODE_ENV === "production"
    ? () => null
    : lazy(() =>
        import("@tanstack/router-devtools").then((res) => ({
          default: res.TanStackRouterDevtools,
          // For Embedded Mode
          // default: res.TanStackRouterDevtoolsPanel
        }))
      );

export const RootView = () => {
  return (
    <>
      <Outlet />

      <Suspense>
        <TanStackRouterDevtools position="bottom-left" toggleButtonProps={{ style: { position: "fixed", left: "12px", bottom: "72px" } }} />
      </Suspense>
    </>
  );
};
